export { default } from './SettingsMailTemplate.jsx';
